module.exports = __webpack_public_path__ + "img/8462a01c3f353d319ed2228b8a2afa50.png";